import { ValidationRules } from '../../../types';

export const validationRules: ValidationRules = {
  email: [{ type: 'email', required: true, message: 'Please enter valid email address' }]
};
